import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef } from '@angular/material';

declare var createjs: any;
import { SessionService } from '../../../shared/services/session.service';

@Component({
  selector: 'app-ex-ch06-page1',
  templateUrl: './ex-ch06-page1.component.html',
  styleUrls: ['./ex-ch06-page1.component.scss']
})
export class ExCh06Page1Component implements OnInit {
  public bloburl: string;
  private stage: any;

  constructor(private sessionService: SessionService, public thisDialogRef: MatDialogRef<ExCh06Page1Component>) { this.bloburl = this.sessionService.bloburl; }

  ngOnInit() {

    var bloburl = this.sessionService.bloburl;
    var isIOS = /iPad|iPhone|iPod/.test(navigator.platform) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)

    var stage = new createjs.Stage("yr3_canvas");
    this.stage = stage;
    createjs.Touch.enable(stage);
    createjs.MotionGuidePlugin.install();

    var yr3_canvas: any = document.getElementById('yr3_canvas');
    yr3_canvas.width = 1785;
    yr3_canvas.height = 890;

    var yr3_bitmap = new createjs.Bitmap(this.bloburl + "/Lasresan/AK3/YR3-RB/Ordvaskan/frame.png");
    yr3_bitmap.setTransform(0, 0, 0.992, 0.97);

    var yr3_heading = new createjs.Text("Ord att förstå", "bold 60px Dk-mariken", "#FF0000");
    if (isIOS) {
      var yr3_heading = new createjs.Text("Ord att förstå", "60px Dk-mariken", "#FF0000");
      yr3_heading.outline = 2;

      var yr3_heading1 = new createjs.Text("Ord att förstå", "60px Dk-mariken", "#FF0000");
      yr3_heading1.textAlign = "center";
      yr3_heading1.setTransform(892, 80);
    }
    yr3_heading.textAlign = "center";
    yr3_heading.setTransform(892, 80);

    var bagclose = new Image();
    bagclose.crossOrigin = "Anonymous";
    bagclose.src = bloburl + "/Lasresan/AK3/YR3-RB/Ordvaskan/bag_close.png";

    var bagopen = new Image();
    bagopen.crossOrigin = "Anonymous";
    bagopen.src = bloburl + "/Lasresan/AK3/YR3-RB/Ordvaskan/bag_open.png";

    var bag_close = new createjs.Bitmap(bagclose);
    bag_close.setTransform(1450, 678, 0.5, 0.5);
    bag_close.cursor = 'pointer';
    bag_close.visible = true;

    var bag_close1 = new createjs.Bitmap(bagclose);
    bag_close1.setTransform(1450, 678, 0.5, 0.5);
    bag_close1.cursor = 'pointer';
    bag_close1.visible = false;
    bag_close1.addEventListener("dblclick", ordsvaken);

    var bag_open = new createjs.Bitmap(bagopen);
    bag_open.setTransform(1450, 622, 0.5, 0.5);
    bag_open.visible = false;

    var yr3_dashed_rect = new createjs.Shape();
    yr3_dashed_rect.graphics.setStrokeStyle(2).f('#FFFFFF').beginStroke("#ED8505").setStrokeDash([6, 6]).drawRoundRect(0, 0, 273, 374.7, 10);
    yr3_dashed_rect.setTransform(135, 375);

    stage.addChild(yr3_dashed_rect);

    var texttable = new Image();
    texttable.crossOrigin = "Anonymous";
    texttable.src = bloburl + "/Lasresan/AK3/YR3-RB/Ordvaskan/texttable.png";

    var text_table = new createjs.Bitmap(texttable);
    text_table.setTransform(649.9, 400);
    text_table.visible = true;

    stage.addChild(text_table);


    function shuffle(obj1, obj2) {
      var index = obj1.length;
      var rnd, tmp1, tmp2;

      while (index) {
        rnd = Math.floor(Math.random() * index);
        index -= 1;
        tmp1 = obj1[index];
        tmp2 = obj2[index];
        obj1[index] = obj1[rnd];
        obj2[index] = obj2[rnd];
        obj1[rnd] = tmp1;
        obj2[rnd] = tmp2;
      }
    }

    ordsvaken();

    function ordsvaken() {

      for (var j = 0; j < stage.children.length; j++) {
        if (stage.children[j].name == "removeimage1") {
          stage.removeChild(stage.children[j]);
          j = j - 1;
        }
      }

      var yr3_exercisecount = -1;

      var dragger1: any = new createjs.Container();
      var yr3_questext1: any = new createjs.Text("täcker", "114px MajemaSkol_Exercise_bold", "#000000");
      yr3_questext1.textBaseline = "alphabetic";
      yr3_questext1.setTransform(0, 100);
      var g1 = yr3_questext1.getBounds();
      var rect1 = new createjs.Shape();
      rect1.graphics.setStrokeStyle(2).f("#FFF000").drawRect(0, 41, g1.width, 85);
      stage.enableMouseOver(20);
      dragger1.addChild(rect1, yr3_questext1);
      dragger1.setTransform(1500, 690);
      dragger1.name = "removeimage1";
      dragger1.alpha = 0;
      dragger1.scaleX = dragger1.scaleY = 0.5;


      var dragger2: any = new createjs.Container();
      var yr3_questext2: any = new createjs.Text("svingar", "114px MajemaSkol_Exercise_bold", "#000000");
      yr3_questext2.textBaseline = "alphabetic";
      yr3_questext2.setTransform(0, 100);
      var g2 = yr3_questext2.getBounds();
      var rect2 = new createjs.Shape();
      rect2.graphics.setStrokeStyle(2).f("#FFF000").drawRect(0, 41, g2.width, 85);
      stage.enableMouseOver(20);
      dragger2.addChild(rect2, yr3_questext2);
      dragger2.setTransform(1500, 690);
      dragger2.name = "removeimage1";
      dragger2.alpha = 0;
      dragger2.scaleX = dragger2.scaleY = 0.5;

      var dragger3: any = new createjs.Container();
      var yr3_questext3: any = new createjs.Text("livnär", "114px MajemaSkol_Exercise_bold", "#000000");
      yr3_questext3.textBaseline = "alphabetic";
      yr3_questext3.setTransform(0, 100);
      var g3 = yr3_questext3.getBounds();
      var rect3 = new createjs.Shape();
      rect3.graphics.setStrokeStyle(2).f("#FFF000").drawRect(0, 41, g3.width, 85);
      stage.enableMouseOver(20);
      dragger3.addChild(rect3, yr3_questext3);
      dragger3.setTransform(1500, 690);
      dragger3.name = "removeimage1";
      dragger3.alpha = 0;
      dragger3.scaleX = dragger3.scaleY = 0.5;

      var dragger4: any = new createjs.Container();
      var yr3_questext4: any = new createjs.Text("klibbiga", "114px MajemaSkol_Exercise_bold", "#000000");
      yr3_questext4.textBaseline = "alphabetic";
      yr3_questext4.setTransform(0, 100);
      var g4 = yr3_questext4.getBounds();
      var rect4 = new createjs.Shape();
      rect4.graphics.setStrokeStyle(2).f("#FFF000").drawRect(0, 41, g4.width, 85);
      stage.enableMouseOver(20);
      dragger4.addChild(rect4, yr3_questext4);
      dragger4.setTransform(1500, 690);
      dragger4.name = "removeimage1";
      dragger4.alpha = 0;
      dragger4.scaleX = dragger4.scaleY = 0.5;

      var dragger5: any = new createjs.Container();
      var yr3_questext5: any = new createjs.Text("fredlig", "114px MajemaSkol_Exercise_bold", "#000000");
      yr3_questext5.textBaseline = "alphabetic";
      yr3_questext5.setTransform(0, 100);
      var g5 = yr3_questext5.getBounds();
      var rect5 = new createjs.Shape();
      rect5.graphics.setStrokeStyle(2).f("#FFF000").drawRect(0, 41, g5.width, 85);
      stage.enableMouseOver(20);
      dragger5.addChild(rect5, yr3_questext5);
      dragger5.setTransform(1500, 690);
      dragger5.name = "removeimage1";
      dragger5.alpha = 0;
      dragger5.scaleX = dragger5.scaleY = 0.5;

      var dragger6: any = new createjs.Container();
      var yr3_questext6: any = new createjs.Text("verktyg", "114px MajemaSkol_Exercise_bold", "#000000");
      yr3_questext6.setTransform(0, 100);
      yr3_questext6.textBaseline = "alphabetic";
      var g6 = yr3_questext6.getBounds();
      var rect6 = new createjs.Shape();
      rect6.graphics.setStrokeStyle(2).f("#FFF000").drawRect(0, 41, g6.width, 85);
      stage.enableMouseOver(20);
      dragger6.addChild(rect6, yr3_questext6);
      dragger6.setTransform(1500, 690);
      dragger6.name = "removeimage1";
      dragger6.alpha = 0;
      dragger6.scaleX = dragger6.scaleY = 0.5;

      var dragger7: any = new createjs.Container();
      var yr3_questext7: any = new createjs.Text("byten", "114px MajemaSkol_Exercise_bold", "#000000");
      yr3_questext7.textBaseline = "alphabetic";
      yr3_questext7.setTransform(0, 100);
      var g7 = yr3_questext7.getBounds();
      var rect7 = new createjs.Shape();
      rect7.graphics.setStrokeStyle(2).f("#FFF000").drawRect(0, 41, g7.width, 85);
      stage.enableMouseOver(20);
      dragger7.addChild(rect7, yr3_questext7);
      dragger7.setTransform(1500, 690);
      dragger7.name = "removeimage1";
      dragger7.alpha = 0;
      dragger7.scaleX = dragger7.scaleY = 0.5;

      var dragger8: any = new createjs.Container();
      var yr3_questext8: any = new createjs.Text("gnagare", "114px MajemaSkol_Exercise_bold", "#000000");
      yr3_questext8.textBaseline = "alphabetic";
      yr3_questext8.setTransform(0, 100);
      var g8 = yr3_questext8.getBounds();
      var rect8 = new createjs.Shape();
      rect8.graphics.setStrokeStyle(2).f("#FFF000").drawRect(0, 41, g8.width, 85);
      stage.enableMouseOver(20);
      dragger8.addChild(rect8, yr3_questext8);
      dragger8.setTransform(1500, 690);
      dragger8.name = "removeimage1";
      dragger8.alpha = 0;
      dragger8.scaleX = dragger8.scaleY = 0.5;

    


      stage.addChild(dragger1, dragger2, dragger3, dragger4, dragger5, dragger6, dragger7, dragger8);

      var draggerarray = [dragger1, dragger2, dragger3, dragger4, dragger5, dragger6, dragger7, dragger8];

      var draggerarray_setbounds = [810.780, 802.914, 823.719, 801.546, 812.946, 792.939, 817.107, 790.431];
      shuffle(draggerarray, draggerarray_setbounds);
      var draggershuffle1: any = [680, 635, 590, 545, 500, 455, 410, 365];

      bag_close.visible = true;
      bag_close1.visible = false;

      bag_close.addEventListener("click", function () {

        bag_close.visible = false;
        bag_open.visible = true;
        yr3_exercisecount += 1;

        if (yr3_exercisecount == 0) {
          createjs.Tween.get(draggerarray[0]).wait(0).to({ scaleX: 1, scaleY: 1, x: draggerarray_setbounds[0], y: 275, alpha: 1 }, 1000);
          createjs.Tween.get(bag_close).wait(1000).to({ visible: true }, 0);
          createjs.Tween.get(bag_open).wait(1000).to({ visible: false }, 0);
        }
        if (yr3_exercisecount == 1) {
          createjs.Tween.get(draggerarray[0].children[0]).wait(0).to({ alpha: 0 }, 1000);
          createjs.Tween.get(draggerarray[0]).wait(0).to({ scaleX: 0.5, scaleY: 0.5, x: 160, y: draggershuffle1[0], alpha: 1 }, 1000);
          createjs.Tween.get(draggerarray[1]).wait(1000).to({ scaleX: 1, scaleY: 1, x: draggerarray_setbounds[1], y: 275, alpha: 1 }, 1000);
          createjs.Tween.get(bag_close).wait(2000).to({ visible: true }, 0);
          createjs.Tween.get(bag_open).wait(2000).to({ visible: false }, 0);
        }
        if (yr3_exercisecount == 2) {
          createjs.Tween.get(draggerarray[1].children[0]).wait(0).to({ alpha: 0 }, 1000);
          createjs.Tween.get(draggerarray[1]).wait(0).to({ scaleX: 0.5, scaleY: 0.5, x: 160, y: draggershuffle1[1], alpha: 1 }, 1000);
          createjs.Tween.get(draggerarray[2]).wait(1000).to({ scaleX: 1, scaleY: 1, x: draggerarray_setbounds[2], y: 275, alpha: 1 }, 1000);
          createjs.Tween.get(bag_close).wait(2000).to({ visible: true }, 0);
          createjs.Tween.get(bag_open).wait(2000).to({ visible: false }, 0);
        }
        if (yr3_exercisecount == 3) {
          createjs.Tween.get(draggerarray[2].children[0]).wait(0).to({ alpha: 0 }, 1000);
          createjs.Tween.get(draggerarray[2]).wait(0).to({ scaleX: 0.5, scaleY: 0.5, x: 160, y: draggershuffle1[2], alpha: 1 }, 1000);
          createjs.Tween.get(draggerarray[3]).wait(1000).to({ scaleX: 1, scaleY: 1, x: draggerarray_setbounds[3], y: 275, alpha: 1 }, 1000);
          createjs.Tween.get(bag_close).wait(2000).to({ visible: true }, 0);
          createjs.Tween.get(bag_open).wait(2000).to({ visible: false }, 0);
        }
        if (yr3_exercisecount == 4) {
          createjs.Tween.get(draggerarray[3].children[0]).wait(0).to({ alpha: 0 }, 1000);
          createjs.Tween.get(draggerarray[3]).wait(0).to({ scaleX: 0.5, scaleY: 0.5, x: 160, y: draggershuffle1[3], alpha: 1 }, 1000);
          createjs.Tween.get(draggerarray[4]).wait(1000).to({ scaleX: 1, scaleY: 1, x: draggerarray_setbounds[4], y: 275, alpha: 1 }, 1000);
          createjs.Tween.get(bag_close).wait(2000).to({ visible: true }, 0);
          createjs.Tween.get(bag_open).wait(2000).to({ visible: false }, 0);
        }
        if (yr3_exercisecount == 5) {
          createjs.Tween.get(draggerarray[4].children[0]).wait(0).to({ alpha: 0 }, 1000);
          createjs.Tween.get(draggerarray[4]).wait(0).to({ scaleX: 0.5, scaleY: 0.5, x: 160, y: draggershuffle1[4], alpha: 1 }, 1000);
          createjs.Tween.get(draggerarray[5]).wait(1000).to({ scaleX: 1, scaleY: 1, x: draggerarray_setbounds[5], y: 275, alpha: 1 }, 1000);
          createjs.Tween.get(bag_close).wait(2000).to({ visible: true }, 0);
          createjs.Tween.get(bag_open).wait(2000).to({ visible: false }, 0);
        }
        if (yr3_exercisecount == 6) {
          createjs.Tween.get(draggerarray[5].children[0]).wait(0).to({ alpha: 0 }, 1000);
          createjs.Tween.get(draggerarray[5]).wait(0).to({ scaleX: 0.5, scaleY: 0.5, x: 160, y: draggershuffle1[5], alpha: 1 }, 1000);
          createjs.Tween.get(draggerarray[6]).wait(1000).to({ scaleX: 1, scaleY: 1, x: draggerarray_setbounds[6], y: 275, alpha: 1 }, 1000);
          createjs.Tween.get(bag_close).wait(2000).to({ visible: true }, 0);
          createjs.Tween.get(bag_open).wait(2000).to({ visible: false }, 0);
        }
        if (yr3_exercisecount == 7) {
          createjs.Tween.get(draggerarray[6].children[0]).wait(0).to({ alpha: 0 }, 1000);
          createjs.Tween.get(draggerarray[6]).wait(0).to({ scaleX: 0.5, scaleY: 0.5, x: 160, y: draggershuffle1[6], alpha: 1 }, 1000);
          createjs.Tween.get(draggerarray[7]).wait(1000).to({ scaleX: 1, scaleY: 1, x: draggerarray_setbounds[7], y: 275, alpha: 1 }, 1000);
          createjs.Tween.get(bag_close).wait(2000).to({ visible: true }, 0);
          createjs.Tween.get(bag_open).wait(2000).to({ visible: false }, 0);
        }

        if (yr3_exercisecount == 8) {
          createjs.Tween.get(draggerarray[7].children[0]).wait(0).to({ alpha: 0 }, 1000);
          createjs.Tween.get(draggerarray[7]).wait(0).to({ scaleX: 0.5, scaleY: 0.5, x: 160, y: draggershuffle1[7], alpha: 1 }, 1000);
          createjs.Tween.get(bag_close).wait(1000).to({ visible: false }, 0);
          createjs.Tween.get(bag_open).wait(1000).to({ visible: false }, 0);
          createjs.Tween.get(bag_close1).wait(1000).to({ visible: true }, 0);
        }


      });
    }
    stage.addChild(yr3_bitmap, yr3_heading, yr3_heading1, bag_close, bag_close1, bag_open);
    stage.enableMouseOver();
    createjs.Ticker.reset();
    createjs.Ticker.framerate = 60;
    createjs.Ticker.addEventListener("tick", this.stage);
    createjs.Ticker.addEventListener("tick", createjs.Tween);
    createjs.Ticker.timingMode = createjs.Ticker.RAF;
  }

  onCloseCancel() {
    createjs.Ticker.reset();
    createjs.Touch.disable(this.stage);
    createjs.Tween.removeAllTweens();
    this.stage.enableMouseOver(0);
    this.stage.clear();
    this.thisDialogRef.close('Cancel');
    
  }
}
